<template>
  <section id="pcMemberPage" class="el-container">
    <div class="deptTree">
      <p class="title">组织架构</p>
      <pcMunberTree
        :editOrgPrivilege="editOrgPrivilege"
        @treeClick="treeClick"
        ref="pcMunberTree"
        @setData="setData"
        v-if="treeShow"
      ></pcMunberTree>
      <div v-if="!treeShow" class="empty-div">暂无数据</div>
    </div>
    <div class="userDiv">
      <p class="title">
        成员列表
        <span v-if="paramsTable.department_name.length > 0"
          >({{ paramsTable.department_name }})</span
        >
      </p>
      <div class="controler">
        <el-row :gutter="20" type="flex" align="middle">
          <el-col :span="24">
            <el-input
              placeholder="输入姓名/手机号"
              clearable
              suffix-icon="el-icon-search"
              v-model="paramsTable.name"
              @change="changeKeyword"
            ></el-input>
            <el-button
              size="small"
              type="primary"
              :disabled="syncUserObj.disabled"
              @click="syncUser"
              >同步{{ syncUserObj.percent }}</el-button
            >
            <el-button
              v-if="editOrgPrivilege"
              size="small"
              @click="importUser"
              type="success"
              >导入</el-button
            >
            <exportB
              exportUrl="/api/contact/export_user"
              progressUrl="/api/contact/imexport_progress"
              downLoadName="成员导出"
            ></exportB>
            <el-button
              v-if="editOrgPrivilege"
              size="small"
              type="info"
              @click="addOrEditUser"
              >新增成员</el-button
            >
          </el-col>
        </el-row>
      </div>
      <section class="main-table">
        <el-table
          v-if="showTable"
          :data="tableData"
          :resizable="true"
          empty-text="暂无数据"
          style="width: 100%"
          :max-height="tableMaxSize"
          header-cell-class-name="table-header-cell height-xs"
          header-row-class-name="table-header-row"
          cell-class-name="table-cell height-xs"
        >
          <el-table-column label="姓名">
            <template slot-scope="scope">
              <template v-if="scope.row.name && scope.row.name.length > 0">
                <span>{{ scope.row.name }}</span>
              </template>
              <template v-else>
                <span>--</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <template v-if="scope.row.phone && scope.row.phone.length > 0">
                <span>{{ scope.row.phone }}</span>
              </template>
              <template v-else>
                <span>--</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="account" label="账号"> </el-table-column>
          <el-table-column label="职务">
            <template slot-scope="scope">
              <template
                v-if="scope.row.position && scope.row.position.length > 0"
              >
                <span>{{ scope.row.position }}</span>
              </template>
              <template v-else>
                <span>--</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column label="邮箱">
            <template slot-scope="scope">
              <template v-if="scope.row.email && scope.row.email.length > 0">
                <span>{{ scope.row.email }}</span>
              </template>
              <template v-else>
                <span>--</span>
              </template>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="dropdown">
                <span
                  @click="showDetail(scope.row, 0)"
                  class="el-dropdown-link"
                >
                  <span> 查看详情</span>
                </span>
                <span
                  v-if="editOrgPrivilege"
                  @click="delUser(scope.row)"
                  class="el-dropdown-link"
                >
                  <span> 删除</span>
                </span>
                <span
                  v-if="editOrgPrivilege"
                  @click="showDetail(scope.row, 1)"
                  class="el-dropdown-link"
                >
                  <span> 修改</span>
                </span>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="page-wrap">
          <pagi
            :page="paramsTable.page"
            :pageSize="paramsTable.pageSize"
            :count="paramsTable.count"
            @pageChange="pageChange"
          ></pagi>
        </div>
      </section>
    </div>
    <!-- 导入数据 -->
    <myUpload
      title="成员导入"
      :process="true"
      :show="uploadDialogParams.show"
      :templateUrl="uploadDialogParams.templateUrl"
      :uploadUrl="uploadDialogParams.uploadUrl"
      :importUrl="uploadDialogParams.importUrl"
      :progressUrl="uploadDialogParams.progressUrl"
      :otherParams="uploadDialogParams.otherParams"
      @updateVisible="importUpdateVisible"
      @callback="importUsercallback"
    >
      <span slot="desc">
        <span>
          3、仅支持模板信息格式，请勿填写其他数据内容
        </span>
        <br />
      </span>
    </myUpload>
    <!-- 增加编辑用户 -->
    <addOrEditUser
      v-if="userObj.dialogVisible"
      :userObj="userObj"
      @cancel="hideAddOrEditUserDialog"
      @confirm="addOrEditUserDialogConfirm"
    ></addOrEditUser>
  </section>
</template>

<script>
import pagi from "@/components/pagi/pagi";
import myUpload from "@/components/myUploadNew";
import pcMunberTree from "@/components/pcMunberTree";
import addOrEditUser from "@/components/pcMunberTree/addOrEditUser";
import confirm from "@/components/elementPlus/packages/confirm";
import exportB from "@/components/export";
export default {
  data() {
    return {
      getTableUrl: "",
      tableData: [],
      paramsTable: {
        page: 1,
        pageSize: 50,
        count: 0,
        department_id: "",
        offset: 0,
        limit: 50,
        name: "",
        type: "2",
        department_name: ""
      },
      tableMaxSize: 0,
      showTable: false,
      defaultExpandedKeys: [],
      detailRow: {},
      uploadDialogParams: {
        show: false,
        templateUrl: "/api/contact/download_demo",
        uploadUrl: "/api/media/upload",
        importUrl: "/api/contact/import_user",
        progressUrl: "/api/contact/imexport_progress",
        otherParams: {}
      },
      userObj: {
        dialogVisible: false
      },
      syncUserObj: {
        percent: "",
        disabled: false,
        taskId: "",
        intervalClass: null
      },
      editOrgPrivilege: false,
      treeShow: true
    };
  },
  components: {
    pcMunberTree,
    pagi,
    myUpload,
    addOrEditUser,
    exportB
  },
  mounted() {
    this.resizeTableHeight();
  },
  methods: {
    setData(val) {
      console.log(val);
      if (val.length === 0) {
        this.treeShow = false;
      } else {
        this.treeShow = true;
      }
    },
    importUser() {
      this.uploadDialogParams.show = true;
    },
    importUpdateVisible(val) {
      this.uploadDialogParams.show = val;
    },
    importUsercallback() {
      this.paramsTable.page = 1;
      this.fetchTableList();
    },
    async showDetail(row, isEdit) {
      this.detailRow = await this.getUserDetail(row.id);
      this.userObj.dialogVisible = true;
      this.userObj.isEdit = isEdit;
      this.userObj.detail = {
        department_ids: JSON.parse(this.detailRow.department_ids),
        account: this.detailRow.account,
        name: this.detailRow.name,
        position: this.detailRow.position,
        telephone: this.detailRow.telephone,
        mobile: this.detailRow.phone,
        email: this.detailRow.email,
        id: this.detailRow.id
      };
    },
    changeKeyword() {
      this.paramsTable.page = 1;
      this.fetchTableList();
    },
    treeClick(data) {
      data.active = true;
      this.paramsTable.department_id = data.id;
      this.paramsTable.page = 1;
      this.paramsTable.department_name = data.name;
      this.getTableUrl = data.getTableUrl;
      this.fetchTableList();
    },
    pageChange(page) {
      this.paramsTable.page = page;
      this.fetchTableList();
    },
    fetchTableList() {
      this.paramsTable.offset =
        (this.paramsTable.page - 1) * this.paramsTable.limit;
      let { department_id, offset, limit, name, type } = this.paramsTable;
      this.$common
        .http({
          // url: "/api/contact/search",
          url: this.getTableUrl,
          data: { department_id, offset, limit, name, type }
        })
        .then(res => {
          this.tableData = res.data.data.items;
          this.paramsTable.count = Number(res.data.data.total);
        });
    },
    getUserDetail(id) {
      return new Promise(resolve => {
        this.$common
          .http({
            url: "/api/contact/user_detail",
            data: { id: id }
          })
          .then(res => {
            return resolve(res.data.data);
          });
      });
    },
    // 设置table高度，计算完成后显示table
    resizeTableHeight() {
      this.tableMaxSize = window.innerHeight - 225;
      this.showTable = true;
    },
    delUser(detail) {
      confirm({
        confirmAc: () => {
          this.$common
            .http({
              url: "/api/contact/delete_user",
              data: {
                id: detail.id
              }
            })
            .then(() => {
              this.$common.pcToastSuccess("删除人员成功");
              this.fetchTableList();
            });
        },
        confirmAcClass: "btnConfirmDanger",
        cancelAcClass: "btnCancel"
      });
      console.log(detail);
    },
    addOrEditUser() {
      this.userObj.dialogVisible = true;
      this.userObj.detail = {
        department_ids: [],
        account: "",
        name: "",
        position: "",
        telephone: "",
        mobile: "",
        id: ""
      };
    },
    hideAddOrEditUserDialog() {
      this.userObj.dialogVisible = false;
    },
    addOrEditUserDialogConfirm() {
      this.paramsTable.page = 1;
      this.fetchTableList();
    },
    syncUser() {
      this.$common
        .http({
          url: "/api/contact/sync_wxwork"
        })
        .then(res => {
          this.syncUserObj.disabled = true;
          this.syncUserObj.taskId = res.data.data.task_id;
          this.syncUserObj.intervalClass = setInterval(() => {
            this.$common
              .http({
                method: "post",
                url: "/api/contact/sync_wxwork_progress",
                data: {
                  task_id: this.syncUserObj.taskId
                },
                noLoading: true
              })
              .then(res1 => {
                this.syncUserObj.percent = +res1.data.data.percent + "%";
                if (res1.data.data.finish == 1) {
                  window.clearInterval(this.syncUserObj.intervalClass);
                  this.syncUserObj.disabled = false;
                  this.syncUserObj.percent = "";
                }
              });
          }, 1000);
        });
    }
  },
  async created() {}
};
</script>

<style scoped lang="less">
@import "assets/css/common";
@borColor: #e4e4e4;
@headheight: 44px;
@treeWidth: 270px;
@tfs: 18px;
@tfw: bold;
#pcMemberPage {
  width: 100%;
  height: 100%;
  p {
    margin: 0;
  }
  .empty-div {
    min-height: 60px;
    text-align: center;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
    font-size: 14px;
  }
  .deptTree {
    width: @treeWidth;
    height: 100%;
    border-right: 1px solid @borColor;
    .title {
      text-align: center;
      height: @headheight;
      line-height: @headheight;
      border-bottom: 1px solid @borColor;
      font-size: @tfs;
      font-weight: @tfw;
    }
  }
  .userDiv {
    width: calc(100% - @treeWidth);
    .title {
      height: @headheight;
      line-height: @headheight;
      padding-left: 10px;
      border-bottom: 1px solid @borColor;
      font-size: @tfs;
      font-weight: @tfw;
    }
    .controler {
      .el-row {
        padding: 10px 10px;
      }
      .el-input {
        width: 180px;
        margin-right: 10px;
      }
    }
    .main-table {
      padding: 0px 10px;
      height: calc(100% - 100px);
    }
    .page-wrap {
      padding: 10px 10px 0 10px;
    }
  }
}
</style>
